export default "__VITE_ASSET__e5b42217__"